export default __webpack_public_path__ + "static/media/avatar_mei_ling6.1b9e69b2.mp3";